import uuid from 'uuid/v4';

export default {
  inMaintenanceMode: false,
  lang: localStorage.getItem('welcmLanguage') || 'en',
  loggedInUser: null,
  customerUUID: localStorage.getItem('customerUUID') || uuid(),
  userLoaded: false,
  translationsLoaded: false,
  currentOverlay: { overlayName: '', overlayData: null },
  userTransactions: [],
  communeInfo: {
    name: 'Keine Kommune selektiert',
    adult_age: 18,
    agb_text: '',
    strictAccommodationSelection: false,
    annual_ticket: {
      active: false,
      direct: false,
      period: 'calendar',
    },
    mandatory_fields: {
      birthday: false,
      city: false,
      email: false,
      mobilenumber: false,
      resortid: false,
      resortname: false,
      street: false,
      zip: false,
    },
    price_options: {
      discountBusiness: false,
      discountDisability: false,
      discountPensioner: false,
      discountResident: false,
      discountStudent: false,
      guesttypeDay: true,
      guesttypeNight: true,
      priceStudent: false,
    },
  },
  communeSelected: null,
  communeSelectedInProcess: null,
  communes: [],
  pageHistory: [{ pageName: null, pageData: null }],
  // ticketBooking: null,
  savedUser: [],
  validTickets: 0,
  benefitCategories: [],
  benefits: [],
  manuallyDefinedSpecialConditions: {},
  favorites: [],
  preferences: [],
  api: {
    version: '0.0.0',
  },
  app: {
    version: process.env.PACKAGE_VERSION || '0',
  },

  ___benefits: [
    {
      benefitId: 1,
      benefitDescription: 'Sie erhalten ein Freigetränk zum Burger-Menü.',
      benefitCategory: 'restaurant',
      benefitTags: ['burger'],
      benefitImage: 'burgermanfred.png',
      venueTitle: 'Burger Manfred',
      venueDescription:
        "Bei Burger Manfred gibt's gekochte Schinkenbrote,dazu leckere Hühnerleber vom Schwein. Frisch aus der Ostsee kommt auch das Himbeersorbet.",
      venueLocation: 'Bergweg 12, 12345 Büsum',
      venueDistance: 12,
      venueRating: 4,
      venueRatingAmount: 52,
      venueWeb: 'https://burgermanfred.de',
      venuePhone: '+49 134 2393 1234',
      venueOpeninghours: 'Geschlossen, Öffnet um 11:00 Uhr',
    },
  ],
};
